import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@core/store/store'

const appVersion = (state: RootState) => state.versionReducer
export const appVersionSelector = createSelector(
  appVersion,
  versionReducer => versionReducer.version,
)

export const lastSyncLicenseDateSelector = createSelector(
  appVersion,
  versionReducer => versionReducer.lastsynclicense,
)
export const lastExternalSyncDateSelector = createSelector(
  appVersion,
  versionReducer => versionReducer.lastExternalSync,
)

export const lastDownloadCompanyResultSelector = createSelector(
  appVersion,
  versionReducer => versionReducer.lastDownloadCompanyResult,
)
